import { createSlice } from "@reduxjs/toolkit";

const inbreedingSlice = createSlice({
  name: "inbreeding",
  initialState: {},
  reducers: {},
});
export default inbreedingSlice.reducer;
